import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlloyButton } from 'cat-ecommerce-alloy';

const HoseWarning = ({ message }) => {
  const [t] = useTranslation();
  const [viewMore, setViewMore] = useState(true);
  const warningText = viewMore ? `${message?.split('.')[0]}.` : message;

  return (
    <>
      <p className="exclude-global d-flex">
        <span className="m-0 ms-4 text-xs">
          <strong className="d-flex">{t('CAT_HOSE_WARNING_HEADER')}</strong>
          {warningText}
        </span>
      </p>
      <AlloyButton
        className="ms-4 p-0 text-xs text-capitalize"
        buttonType="link"
        type="button"
        onClick={() => setViewMore(viewMore => !viewMore)}
      >
        {viewMore ? t('VIEW_MORE_PRODUCTS') : t('VIEW_LESS')}
      </AlloyButton>
    </>
  );
};

HoseWarning.propTypes = {
  message: PropTypes.string.isRequired
};

export default HoseWarning;
